// Three-segment match-strength bar for the pool-order list row.
// Brass = matched, muted-brass = suggested, dim = unmatched.

interface MatchBarProps {
  matched: number;
  suggested: number;
  unmatched: number;
}

export function MatchBar({ matched, suggested, unmatched }: MatchBarProps) {
  const total = matched + suggested + unmatched;
  if (total === 0) {
    return <div className="h-1.5 w-full bg-bg-input rounded-sm" />;
  }
  const pct = (n: number) => `${(n / total) * 100}%`;
  return (
    <div className="flex h-1.5 w-full overflow-hidden rounded-sm bg-bg-input">
      <div className="bg-accent"        style={{ width: pct(matched) }} />
      <div className="bg-accent/40"     style={{ width: pct(suggested) }} />
      <div className="bg-text-faint/30" style={{ width: pct(unmatched) }} />
    </div>
  );
}
